import { CSSProperties, forwardRef, ReactNode } from "react";

interface PrintableContentProps {
  children: ReactNode;
  style?: CSSProperties;
}

const PrintableContent = forwardRef<HTMLDivElement, PrintableContentProps>(
  ({ children, style = {} }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          position: "absolute",
          left: "-9999px", // Move off-screen instead of display: none
          opacity: 1, // Keep it hidden
          width: "210mm", // A4 width
          minHeight: "297mm", // A4 height
          backgroundColor: "white",
          border: "none",
          paddingTop: "10mm", // Increased top padding for extra space
          paddingBottom: "10mm", // Increased bottom padding for extra space
          paddingLeft: "15mm",
          paddingRight: "15mm",
          boxSizing: "border-box",
          pageBreakBefore: "always", // Forces new page when necessary
          pageBreakAfter: "always", // Ensures a break after each page
          margin: "10 auto",
          breakInside: "avoid", // Prevents content from breaking inside elements
          overflow: "hidden", // Prevent content overflow
          ...style,
        }}
      >
        {children}
      </div>
    );
  }
);

export default PrintableContent;
